import { render, staticRenderFns } from "./LandingSectionFacts.vue?vue&type=template&id=5c0dd599&scoped=true&"
import script from "./LandingSectionFacts.vue?vue&type=script&lang=js&"
export * from "./LandingSectionFacts.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionFacts.vue?vue&type=style&index=0&id=5c0dd599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0dd599",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default})
